export default "__VITE_ASSET__Dv$SIfVt__"